import React from 'react';
import './BacgroundFooter.css'

const BackgroundFooter = () => {
    return (
        <div className=' footer-container1'>
            <div className="footer-parent1">
                <img className='w-screen ' src={require ('../../img/wave.png')} alt='no internet'/>
                
            </div>
            
        </div>
    );
};

export default BackgroundFooter;